import script from "./TasksWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./TasksWidget.vue?vue&type=script&setup=true&lang=js"

import "./TasksWidget.vue?vue&type=style&index=0&id=fa11cd66&lang=css"

const __exports__ = script;

export default __exports__